export default __webpack_public_path__ + "static/media/terms-and-conds.d5350730.svg";